/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: webapp-contrib
 * Version: 7.1.2
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
(function ($) {
    // Ne sera déclenché que si l'écran d'affectation des rôles est utilisé
    if (window.arrayRoles) {
        function soumettreAjoutAffectation(indiceModification, $form) {
            if (indiceModification !== -1) {
                //modification
                $form.find('input[name="ACTION"]').val('AJOUTER_AFFECTATION#'+indiceModification);
            } else {//ajout
                $form.find('input[name="ACTION"]').val('AJOUTER_AFFECTATION');
            }
            $form.submit();
            modifierBouton('AJOUTER_AFFECTATION','Ajouter', -1);
        }

        function soumettreSuppressionAffectation(i, $form) {
            $form.find('input[name="ACTION"]').val('SUPPRIMER_AFFECTATION#' + i);
            $form.submit();
        }

        function affichePerimetre() {
            var $structure = $('#kMonoSelectSTRUCTURE_AFFECTATION'),
                $rubrique = $('#kMonoSelectRUBRIQUE_AFFECTATION'),
                $groupe = $('#kMonoSelectGROUPE_AFFECTATION'),
                codeRole = $('#ROLE_AFFECTATION').val();
            $rubrique.kMonoSelect().clear();
            $structure.kMonoSelect().clear();
            $groupe.kMonoSelect().clear();

            displayPerimetres(codeRole);
        }

        //au clic sur le lien "modifier", appel de cette méthode qui
        //affiche les rubrique, structure et groupe du rôle à modifier.
        function affichePerimetreModification($this) {
            var index = $this.data('index'),
                codeRole = $this.data('role'),
                structureCourante = $this.data('structure'),
                libelleStructureCourante = $this.data('libellestructure'),
                rubriqueCourante = $this.data('rubrique'),
                libelleRubriqueCourante = $this.data('libellerubrique'),
                groupeCourant = $this.data('groupe'),
                libelleGroupeCourant = $this.data('libellegroupe');

            var $role = $('#ROLE_AFFECTATION'),
                selects = $('.kmonoselect'),
                $codeStructure = $('#STRUCTURE_AFFECTATION'),
                $codeRubrique = $('#RUBRIQUE_AFFECTATION'),
                $codeGroupe = $('#GROUPE_AFFECTATION'),
                libelleStructure = $(selects[1]),
                libelleRubrique = $(selects[2]),
                libelleGroupe = $(selects[3]);

            $role.val(codeRole);
            document.querySelector('#ROLE_AFFECTATION').setAttribute('disabled', 'true');
            //On charge dans les arbres les valeurs du rôle en cours de modification
            $codeStructure.val(structureCourante);
            $codeRubrique.val(rubriqueCourante);
            $codeGroupe.val(groupeCourant);
            //On charge les libellés des rubriques, groupes et structures du rôle en cours de modification
            libelleStructure.kMonoSelect().value(libelleStructureCourante);
            libelleRubrique.kMonoSelect().value(libelleRubriqueCourante);
            libelleGroupe.kMonoSelect().value(libelleGroupeCourant);

            displayPerimetres(codeRole);
            modifierBouton('MODIFIER_AFFECTATION#', 'Modifier', index);
        }

        function displayPerimetres(codeRole){
            var $perimetreRubrique = $('#perimetreRubrique'),
                $perimetreStructure = $('#perimetreStructure'),
                $perimetreGroupe = $('#perimetreGroupe');
            if (codeRole === '0000') {
                $perimetreRubrique.css({display: 'none'});
                $perimetreStructure.css({display: 'none'});
                $perimetreGroupe.css({display: 'none'});
                return;
            }
            for (var i = 0; i < arrayRoles.length; i++) {
                var role = arrayRoles[i];
                if (role.code == codeRole) {
                    if ($perimetreStructure.length > 0) {
                        if (role.structure === '1') {
                            $perimetreStructure.css({display: ''});
                            $('#messagePerimetreStructure').css({display: ''});
                        } else {
                            $perimetreStructure.css({display: 'none'});
                            $('#messagePerimetreStructure').css({display: 'none'});
                        }
                    }
                    if ($perimetreRubrique.length > 0) {
                        if (role.rubrique === '1') {
                            $perimetreRubrique.css({display: ''});
                            $('#messagePerimetreStructure').css({display: ''});
                        } else {
                            $perimetreRubrique.css({display: 'none'});
                            $('#messagePerimetreStructure').css({display: 'none'});
                        }
                    }
                    if ($perimetreGroupe.length > 0) {
                        if (role.groupe === '1') {
                            $perimetreGroupe.css({display: ''});
                            $('#messagePerimetreGroupe').css({display: ''});
                        } else {
                            $perimetreGroupe.css({display: 'none'});
                            $('#messagePerimetreGroupe').css({display: 'none'});
                        }
                    }
                }
            }
        }

        //modification des attributs du bouton "Ajouter" qui devient "Modifier" lors d'un clic sur
        //un lien de modification dans le tableau. Et inversement une fois la modification faite.
        function modifierBouton(idBoutton, valueBouton, index) {
            var boutonModifier = document.querySelector('.js-bouton-ajout');
            if (boutonModifier != null) {
                if (index !== -1) {//modification
                    boutonModifier.setAttribute('name', idBoutton + index);
                    boutonModifier.setAttribute('id', idBoutton + index);
                } else {//ajout
                    boutonModifier.setAttribute('name', idBoutton);
                    boutonModifier.setAttribute('id', idBoutton);
                }
                boutonModifier.setAttribute('value', valueBouton);
            }
        }

        // Gestion des évènements
        $('#AJOUTER_AFFECTATION').click(function () {
            //si il y a un #, c'est une modification
            var indiceDiese = this.id.indexOf('#'),
                index = -1;
            if (indiceDiese !== -1) {
                index = this.id.substr(indiceDiese + 1);
            }
            soumettreAjoutAffectation(index, $(this.closest('form')));
            return false;
        });
        [].forEach.call(document.querySelectorAll('#ANNULER_MODIFICATION_AFFECTATION'), function(e) {
            e.addEventListener('click', function() {
                var $form = $(e.closest('form'));
                $form.find('input[name="ACTION"]').val('ANNULER_MODIFICATION_AFFECTATION');
                $form.submit();
                return false;
            });
        });
        $('#ROLE_AFFECTATION').change(function () {
            affichePerimetre();
        });
        $('#divAutorisations').on('click', '.js-delete-role-user', function(){
            var $this = $(this),
                index = $this.data('role');
            soumettreSuppressionAffectation(index, $(this.closest('form')));
        });
        $('#divAutorisations').on('click', '.js-update-role-user', function () {
            $('.js-bouton-annulation').css({display: ''});
            var $this = $(this);
            affichePerimetreModification($this, $(this.closest('form')));
        });
        // Affichage au chargement de la page
        affichePerimetre();
    }
})(jQuery.noConflict());
